export default "__VITE_ASSET__fd4ed107__"